//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IKimTeilnehmerRestApi {
    /**
     * @return deregistration done
     */
    deregistrierungUsingPOST(body: AccountDeregistrierenFrontendRequestDTO): Observable<AccountDeregistrierenResponseDTO>;
    /**
     * Antrag zum Entsperren eines KIM Accounts.
     * @return unlock don
     */
    entsperrenUsingPOST(body: AccountEntsperrenRequestDTO): Observable<AccountEntsperrenResponseDTO>;
    /**
     * Liefert alle Maildomänen die für Teilnehmerregistrierung zugelassen sind
     * @return Liefert alle Maildomänen die für Teilnehmerregistrierung zugelassen sind
     */
    holeMailDomaeneRegistrierungUsingGET(vertragId: string): Observable<HoleMailDomaeneFuerVertragResponseDTO>;
    /**
     * KIM Teilnehmer registrieren
     * @return registration done
     */
    registrierungUsingPOST(body: TeilnehmerregistrierungRequestDTO): Observable<TeilnehmerregistrierungResponseDTO>;
    /**
     * @return certificate downloaded
     */
    abrufZertifikatFurTeilnehmerUsingPOST(body: AbrufZertifikatRequestDTO): Observable<AbrufZertifikatResponseDTO>;
    /**
     * @return get list of certificates for a Teilnehmer
     */
    zertifikateDurchTeilnehmerUsingPOST(body: ZertifikateDurchTeilnehmerRequestDTO): Observable<ZertifikateDurchTeilnehmerResponseDTO>;
    /**
     * Deregistrierung durch Anbieter erzwingen
     * @return forced account deregistration result returned
     */
    erzwingeDeregistrierungUsingPOST(body: AccountDeregistrierenZwangRequestDTO): Observable<AccountDeregistrierenResponseDTO>;
    /**
     * Kim Accountdetails erhalten
     * @return account returned
     */
    getAccountDetailsUsingPOST(body: AccountDetailsRequestDTO): Observable<AccountDetailsResponseDTO>;
    /**
     * Volumenstatistik des Accounts erhalten
     * @return account volume statistic returned
     */
    holeAccountVolumenStatistikUsingPOST(body: AccountVolumenStatistikRequestDTO): Observable<AccountVolumenStatistikResponseDTO>;
}

@Injectable()
export class KimTeilnehmerRestApi implements IKimTeilnehmerRestApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:8081";
    }

    /**
     * @return deregistration done
     */
    deregistrierungUsingPOST(body: AccountDeregistrierenFrontendRequestDTO): Observable<AccountDeregistrierenResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/account/deregistrierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeregistrierungUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeregistrierungUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDeregistrierenResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDeregistrierenResponseDTO>;
        }));
    }

    protected processDeregistrierungUsingPOST(response: HttpResponseBase): Observable<AccountDeregistrierenResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDeregistrierenResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while deregistering ", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDeregistrierenResponseDTO>(null as any);
    }

    /**
     * Antrag zum Entsperren eines KIM Accounts.
     * @return unlock don
     */
    entsperrenUsingPOST(body: AccountEntsperrenRequestDTO): Observable<AccountEntsperrenResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/account/entsperren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntsperrenUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntsperrenUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountEntsperrenResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountEntsperrenResponseDTO>;
        }));
    }

    protected processEntsperrenUsingPOST(response: HttpResponseBase): Observable<AccountEntsperrenResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while unlock", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountEntsperrenResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountEntsperrenResponseDTO>(null as any);
    }

    /**
     * Liefert alle Maildomänen die für Teilnehmerregistrierung zugelassen sind
     * @return Liefert alle Maildomänen die für Teilnehmerregistrierung zugelassen sind
     */
    holeMailDomaeneRegistrierungUsingGET(vertragId: string): Observable<HoleMailDomaeneFuerVertragResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/maildomaene/mailDomaeneRegistrierung?";
        if (vertragId === undefined || vertragId === null)
            throw new Error("The parameter 'vertragId' must be defined and cannot be null.");
        else
            url_ += "vertragId=" + encodeURIComponent("" + vertragId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHoleMailDomaeneRegistrierungUsingGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHoleMailDomaeneRegistrierungUsingGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HoleMailDomaeneFuerVertragResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HoleMailDomaeneFuerVertragResponseDTO>;
        }));
    }

    protected processHoleMailDomaeneRegistrierungUsingGET(response: HttpResponseBase): Observable<HoleMailDomaeneFuerVertragResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HoleMailDomaeneFuerVertragResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("Fehler beim Holen der Maildom\u00e4nen f\u00fcr Registrierung", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HoleMailDomaeneFuerVertragResponseDTO>(null as any);
    }

    /**
     * KIM Teilnehmer registrieren
     * @return registration done
     */
    registrierungUsingPOST(body: TeilnehmerregistrierungRequestDTO): Observable<TeilnehmerregistrierungResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/teilnehmer/registrierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegistrierungUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegistrierungUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeilnehmerregistrierungResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeilnehmerregistrierungResponseDTO>;
        }));
    }

    protected processRegistrierungUsingPOST(response: HttpResponseBase): Observable<TeilnehmerregistrierungResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while registering ", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeilnehmerregistrierungResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeilnehmerregistrierungResponseDTO>(null as any);
    }

    /**
     * @return certificate downloaded
     */
    abrufZertifikatFurTeilnehmerUsingPOST(body: AbrufZertifikatRequestDTO): Observable<AbrufZertifikatResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/zertifikat/zertifikateAbruf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbrufZertifikatFurTeilnehmerUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbrufZertifikatFurTeilnehmerUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbrufZertifikatResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbrufZertifikatResponseDTO>;
        }));
    }

    protected processAbrufZertifikatFurTeilnehmerUsingPOST(response: HttpResponseBase): Observable<AbrufZertifikatResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while downloading certificate", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbrufZertifikatResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbrufZertifikatResponseDTO>(null as any);
    }

    /**
     * @return get list of certificates for a Teilnehmer
     */
    zertifikateDurchTeilnehmerUsingPOST(body: ZertifikateDurchTeilnehmerRequestDTO): Observable<ZertifikateDurchTeilnehmerResponseDTO> {
        let url_ = this.baseUrl + "/rest/kim/zertifikat/zertifikateDurchTeilnehmer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZertifikateDurchTeilnehmerUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZertifikateDurchTeilnehmerUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZertifikateDurchTeilnehmerResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZertifikateDurchTeilnehmerResponseDTO>;
        }));
    }

    protected processZertifikateDurchTeilnehmerUsingPOST(response: HttpResponseBase): Observable<ZertifikateDurchTeilnehmerResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZertifikateDurchTeilnehmerResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while getting the list of certificates for a Teilnehmer", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZertifikateDurchTeilnehmerResponseDTO>(null as any);
    }

    /**
     * Deregistrierung durch Anbieter erzwingen
     * @return forced account deregistration result returned
     */
    erzwingeDeregistrierungUsingPOST(body: AccountDeregistrierenZwangRequestDTO): Observable<AccountDeregistrierenResponseDTO> {
        let url_ = this.baseUrl + "/rest/oauth/kim/account/erzwingeDeregistrierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processErzwingeDeregistrierungUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processErzwingeDeregistrierungUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDeregistrierenResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDeregistrierenResponseDTO>;
        }));
    }

    protected processErzwingeDeregistrierungUsingPOST(response: HttpResponseBase): Observable<AccountDeregistrierenResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while deregistering account", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDeregistrierenResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDeregistrierenResponseDTO>(null as any);
    }

    /**
     * Kim Accountdetails erhalten
     * @return account returned
     */
    getAccountDetailsUsingPOST(body: AccountDetailsRequestDTO): Observable<AccountDetailsResponseDTO> {
        let url_ = this.baseUrl + "/rest/oauth/kim/account/getAccountDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDetailsUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDetailsUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDetailsResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDetailsResponseDTO>;
        }));
    }

    protected processGetAccountDetailsUsingPOST(response: HttpResponseBase): Observable<AccountDetailsResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDetailsResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while getting account details", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDetailsResponseDTO>(null as any);
    }

    /**
     * Volumenstatistik des Accounts erhalten
     * @return account volume statistic returned
     */
    holeAccountVolumenStatistikUsingPOST(body: AccountVolumenStatistikRequestDTO): Observable<AccountVolumenStatistikResponseDTO> {
        let url_ = this.baseUrl + "/rest/oauth/kim/account/getAccountVolumen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHoleAccountVolumenStatistikUsingPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHoleAccountVolumenStatistikUsingPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountVolumenStatistikResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountVolumenStatistikResponseDTO>;
        }));
    }

    protected processHoleAccountVolumenStatistikUsingPOST(response: HttpResponseBase): Observable<AccountVolumenStatistikResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDTO.fromJS(resultData400);
            return throwException("error while getting account volume statistic", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountVolumenStatistikResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountVolumenStatistikResponseDTO>(null as any);
    }
}

export class AccountVolumenStatistikRequestDTO implements IAccountVolumenStatistikRequestDTO {
    kimEmail?: string;

    constructor(data?: IAccountVolumenStatistikRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimEmail = _data["kimEmail"];
        }
    }

    static fromJS(data: any): AccountVolumenStatistikRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVolumenStatistikRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimEmail"] = this.kimEmail;
        return data;
    }
}

export interface IAccountVolumenStatistikRequestDTO {
    kimEmail?: string;
}

/** Domain error information */
export class ErrorDTO implements IErrorDTO {
    /** Error-Code of application */
    errorCode?: string;
    /** Subcode for more specific error */
    errorSubcode?: string;
    /** Exception which has occured */
    exception?: string;
    /** Exception message */
    errorMessages?: string[];

    constructor(data?: IErrorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.errorSubcode = _data["errorSubcode"];
            this.exception = _data["exception"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }

    static fromJS(data: any): ErrorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["errorSubcode"] = this.errorSubcode;
        data["exception"] = this.exception;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

/** Domain error information */
export interface IErrorDTO {
    /** Error-Code of application */
    errorCode?: string;
    /** Subcode for more specific error */
    errorSubcode?: string;
    /** Exception which has occured */
    exception?: string;
    /** Exception message */
    errorMessages?: string[];
}

export class AccountVolumenDTO implements IAccountVolumenDTO {
    period?: Date;
    kimEmail?: string;
    sentVolume?: number;
    receiveVolume?: number;

    constructor(data?: IAccountVolumenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.kimEmail = _data["kimEmail"];
            this.sentVolume = _data["sentVolume"];
            this.receiveVolume = _data["receiveVolume"];
        }
    }

    static fromJS(data: any): AccountVolumenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVolumenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toISOString() : <any>undefined;
        data["kimEmail"] = this.kimEmail;
        data["sentVolume"] = this.sentVolume;
        data["receiveVolume"] = this.receiveVolume;
        return data;
    }
}

export interface IAccountVolumenDTO {
    period?: Date;
    kimEmail?: string;
    sentVolume?: number;
    receiveVolume?: number;
}

export class AccountVolumenStatistikResponseDTO implements IAccountVolumenStatistikResponseDTO {
    success?: boolean;
    volumen?: AccountVolumenDTO[];

    constructor(data?: IAccountVolumenStatistikResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["volumen"])) {
                this.volumen = [] as any;
                for (let item of _data["volumen"])
                    this.volumen.push(AccountVolumenDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountVolumenStatistikResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVolumenStatistikResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.volumen)) {
            data["volumen"] = [];
            for (let item of this.volumen)
                data["volumen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountVolumenStatistikResponseDTO {
    success?: boolean;
    volumen?: AccountVolumenDTO[];
}

export class AccountDetailsRequestDTO implements IAccountDetailsRequestDTO {
    kimEmail: string;

    constructor(data?: IAccountDetailsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimEmail = _data["kimEmail"];
        }
    }

    static fromJS(data: any): AccountDetailsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDetailsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimEmail"] = this.kimEmail;
        return data;
    }
}

export interface IAccountDetailsRequestDTO {
    kimEmail: string;
}

export class AccountDTO implements IAccountDTO {
    accountId?: string;
    kimEmail?: string;
    publicEmail?: string;
    type?: string;
    mailboxSize?: string;
    registered?: Date;
    activated?: Date;
    deregistered?: Date;
    state?: string;
    historie?: AccountHistoryEntryDTO[];

    constructor(data?: IAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.kimEmail = _data["kimEmail"];
            this.publicEmail = _data["publicEmail"];
            this.type = _data["type"];
            this.mailboxSize = _data["mailboxSize"];
            this.registered = _data["registered"] ? new Date(_data["registered"].toString()) : <any>undefined;
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : <any>undefined;
            this.deregistered = _data["deregistered"] ? new Date(_data["deregistered"].toString()) : <any>undefined;
            this.state = _data["state"];
            if (Array.isArray(_data["historie"])) {
                this.historie = [] as any;
                for (let item of _data["historie"])
                    this.historie.push(AccountHistoryEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["kimEmail"] = this.kimEmail;
        data["publicEmail"] = this.publicEmail;
        data["type"] = this.type;
        data["mailboxSize"] = this.mailboxSize;
        data["registered"] = this.registered ? this.registered.toISOString() : <any>undefined;
        data["activated"] = this.activated ? this.activated.toISOString() : <any>undefined;
        data["deregistered"] = this.deregistered ? this.deregistered.toISOString() : <any>undefined;
        data["state"] = this.state;
        if (Array.isArray(this.historie)) {
            data["historie"] = [];
            for (let item of this.historie)
                data["historie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountDTO {
    accountId?: string;
    kimEmail?: string;
    publicEmail?: string;
    type?: string;
    mailboxSize?: string;
    registered?: Date;
    activated?: Date;
    deregistered?: Date;
    state?: string;
    historie?: AccountHistoryEntryDTO[];
}

export class AccountDetailsResponseDTO implements IAccountDetailsResponseDTO {
    account?: AccountDTO;
    success?: boolean;

    constructor(data?: IAccountDetailsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"] ? AccountDTO.fromJS(_data["account"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AccountDetailsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDetailsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IAccountDetailsResponseDTO {
    account?: AccountDTO;
    success?: boolean;
}

export class AccountHistoryEntryDTO implements IAccountHistoryEntryDTO {
    aenderungDatum?: Date;
    operation?: string;
    kimEmail?: string;
    publicEmail?: string;
    status?: string;
    kommentar?: string;
    startDerLoeschfrist?: Date;
    startDeregistrierung?: Date;

    constructor(data?: IAccountHistoryEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aenderungDatum = _data["aenderungDatum"] ? new Date(_data["aenderungDatum"].toString()) : <any>undefined;
            this.operation = _data["operation"];
            this.kimEmail = _data["kimEmail"];
            this.publicEmail = _data["publicEmail"];
            this.status = _data["status"];
            this.kommentar = _data["kommentar"];
            this.startDerLoeschfrist = _data["startDerLoeschfrist"] ? new Date(_data["startDerLoeschfrist"].toString()) : <any>undefined;
            this.startDeregistrierung = _data["startDeregistrierung"] ? new Date(_data["startDeregistrierung"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountHistoryEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountHistoryEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aenderungDatum"] = this.aenderungDatum ? this.aenderungDatum.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        data["kimEmail"] = this.kimEmail;
        data["publicEmail"] = this.publicEmail;
        data["status"] = this.status;
        data["kommentar"] = this.kommentar;
        data["startDerLoeschfrist"] = this.startDerLoeschfrist ? this.startDerLoeschfrist.toISOString() : <any>undefined;
        data["startDeregistrierung"] = this.startDeregistrierung ? this.startDeregistrierung.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAccountHistoryEntryDTO {
    aenderungDatum?: Date;
    operation?: string;
    kimEmail?: string;
    publicEmail?: string;
    status?: string;
    kommentar?: string;
    startDerLoeschfrist?: Date;
    startDeregistrierung?: Date;
}

export class AccountDeregistrierenZwangRequestDTO implements IAccountDeregistrierenZwangRequestDTO {
    kimEmail?: string;
    kimContractId?: string;
    kommentar?: string;

    constructor(data?: IAccountDeregistrierenZwangRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimEmail = _data["kimEmail"];
            this.kimContractId = _data["kimContractId"];
            this.kommentar = _data["kommentar"];
        }
    }

    static fromJS(data: any): AccountDeregistrierenZwangRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDeregistrierenZwangRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimEmail"] = this.kimEmail;
        data["kimContractId"] = this.kimContractId;
        data["kommentar"] = this.kommentar;
        return data;
    }
}

export interface IAccountDeregistrierenZwangRequestDTO {
    kimEmail?: string;
    kimContractId?: string;
    kommentar?: string;
}

export class AccountDeregistrierenResponseDTO implements IAccountDeregistrierenResponseDTO {
    /** Zeigt an, ob die Deregistrierung erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Deregistrierung. */
    bemerkung?: string;
    /** Token für die weiteren Schritte zum Deregistrieren des Accounts. */
    deregistrierungstoken?: string;

    constructor(data?: IAccountDeregistrierenResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bemerkung = _data["bemerkung"];
            this.deregistrierungstoken = _data["deregistrierungstoken"];
        }
    }

    static fromJS(data: any): AccountDeregistrierenResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDeregistrierenResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bemerkung"] = this.bemerkung;
        data["deregistrierungstoken"] = this.deregistrierungstoken;
        return data;
    }
}

export interface IAccountDeregistrierenResponseDTO {
    /** Zeigt an, ob die Deregistrierung erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Deregistrierung. */
    bemerkung?: string;
    /** Token für die weiteren Schritte zum Deregistrieren des Accounts. */
    deregistrierungstoken?: string;
}

export class ZertifikateDurchTeilnehmerRequestDTO implements IZertifikateDurchTeilnehmerRequestDTO {
    kimContractId?: string;
    zertifikatsnummer?: string;
    kimEmail?: string;
    kimPasswort?: string;

    constructor(data?: IZertifikateDurchTeilnehmerRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimContractId = _data["kimContractId"];
            this.zertifikatsnummer = _data["zertifikatsnummer"];
            this.kimEmail = _data["kimEmail"];
            this.kimPasswort = _data["kimPasswort"];
        }
    }

    static fromJS(data: any): ZertifikateDurchTeilnehmerRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZertifikateDurchTeilnehmerRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimContractId"] = this.kimContractId;
        data["zertifikatsnummer"] = this.zertifikatsnummer;
        data["kimEmail"] = this.kimEmail;
        data["kimPasswort"] = this.kimPasswort;
        return data;
    }
}

export interface IZertifikateDurchTeilnehmerRequestDTO {
    kimContractId?: string;
    zertifikatsnummer?: string;
    kimEmail?: string;
    kimPasswort?: string;
}

export class ZertifikatDurchTeilnehmerDTO implements IZertifikatDurchTeilnehmerDTO {
    zertifikatId?: number;
    groesse?: string;
    datum?: Date;
    status?: string;

    constructor(data?: IZertifikatDurchTeilnehmerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zertifikatId = _data["zertifikatId"];
            this.groesse = _data["groesse"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ZertifikatDurchTeilnehmerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZertifikatDurchTeilnehmerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zertifikatId"] = this.zertifikatId;
        data["groesse"] = this.groesse;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IZertifikatDurchTeilnehmerDTO {
    zertifikatId?: number;
    groesse?: string;
    datum?: Date;
    status?: string;
}

export class ZertifikateDurchTeilnehmerResponseDTO implements IZertifikateDurchTeilnehmerResponseDTO {
    success?: boolean;
    bemerkung?: string;
    zertifikateDurchTeilnehmer?: ZertifikatDurchTeilnehmerDTO[];

    constructor(data?: IZertifikateDurchTeilnehmerResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bemerkung = _data["bemerkung"];
            if (Array.isArray(_data["zertifikateDurchTeilnehmer"])) {
                this.zertifikateDurchTeilnehmer = [] as any;
                for (let item of _data["zertifikateDurchTeilnehmer"])
                    this.zertifikateDurchTeilnehmer.push(ZertifikatDurchTeilnehmerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZertifikateDurchTeilnehmerResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZertifikateDurchTeilnehmerResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bemerkung"] = this.bemerkung;
        if (Array.isArray(this.zertifikateDurchTeilnehmer)) {
            data["zertifikateDurchTeilnehmer"] = [];
            for (let item of this.zertifikateDurchTeilnehmer)
                data["zertifikateDurchTeilnehmer"].push(item.toJSON());
        }
        return data;
    }
}

export interface IZertifikateDurchTeilnehmerResponseDTO {
    success?: boolean;
    bemerkung?: string;
    zertifikateDurchTeilnehmer?: ZertifikatDurchTeilnehmerDTO[];
}

export class AbrufZertifikatRequestDTO implements IAbrufZertifikatRequestDTO {
    /** kim+ Contract ID als weitere Vertrags Referenz. */
    kimContractId: string;
    /** kim+ E-Mail-Adresse, für den das Zertifikat abgerufen werden soll. */
    kimEmailAdresse: string;
    /** Passwort des referenzierten kim+ E-Mail Accounts. */
    kimPasswort: string;
    /** ID des Zertifikats, für das Informationen abgerufen werden. */
    zertifikatsnummer: number;

    constructor(data?: IAbrufZertifikatRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimContractId = _data["kimContractId"];
            this.kimEmailAdresse = _data["kimEmailAdresse"];
            this.kimPasswort = _data["kimPasswort"];
            this.zertifikatsnummer = _data["zertifikatsnummer"];
        }
    }

    static fromJS(data: any): AbrufZertifikatRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AbrufZertifikatRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimContractId"] = this.kimContractId;
        data["kimEmailAdresse"] = this.kimEmailAdresse;
        data["kimPasswort"] = this.kimPasswort;
        data["zertifikatsnummer"] = this.zertifikatsnummer;
        return data;
    }
}

export interface IAbrufZertifikatRequestDTO {
    /** kim+ Contract ID als weitere Vertrags Referenz. */
    kimContractId: string;
    /** kim+ E-Mail-Adresse, für den das Zertifikat abgerufen werden soll. */
    kimEmailAdresse: string;
    /** Passwort des referenzierten kim+ E-Mail Accounts. */
    kimPasswort: string;
    /** ID des Zertifikats, für das Informationen abgerufen werden. */
    zertifikatsnummer: number;
}

export class AbrufZertifikatResponseDTO implements IAbrufZertifikatResponseDTO {
    zertifikat?: string;
    gueltig?: boolean;
    bemerkung?: string;

    constructor(data?: IAbrufZertifikatResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zertifikat = _data["zertifikat"];
            this.gueltig = _data["gueltig"];
            this.bemerkung = _data["bemerkung"];
        }
    }

    static fromJS(data: any): AbrufZertifikatResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AbrufZertifikatResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zertifikat"] = this.zertifikat;
        data["gueltig"] = this.gueltig;
        data["bemerkung"] = this.bemerkung;
        return data;
    }
}

export interface IAbrufZertifikatResponseDTO {
    zertifikat?: string;
    gueltig?: boolean;
    bemerkung?: string;
}

export class AccountinformationenRequestDTO implements IAccountinformationenRequestDTO {
    /** E-Mail-Adresse des zu deregistrierenden Accounts. */
    kimEmail: string;

    constructor(data?: IAccountinformationenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimEmail = _data["kimEmail"];
        }
    }

    static fromJS(data: any): AccountinformationenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountinformationenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimEmail"] = this.kimEmail;
        return data;
    }
}

export interface IAccountinformationenRequestDTO {
    /** E-Mail-Adresse des zu deregistrierenden Accounts. */
    kimEmail: string;
}

export class RegistrierungsinformationenRequestDTO implements IRegistrierungsinformationenRequestDTO {
    /** Öffentliche E-Mail-Adresse des Teilnehmers zur Versendung von Registrierungsinformationen. */
    email: string;
    /** Lebenslange Arztnummer, optional. */
    lanr?: string;
    /** Betriebsstättennummer, optional. */
    bsnr?: string;
    /** Nummer der Kassenzahnärztlichen Vereinigung, optional. */
    kzvnr?: string;
    /** Institutskennzeichen, optional. */
    iknr?: string;

    constructor(data?: IRegistrierungsinformationenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.lanr = _data["lanr"];
            this.bsnr = _data["bsnr"];
            this.kzvnr = _data["kzvnr"];
            this.iknr = _data["iknr"];
        }
    }

    static fromJS(data: any): RegistrierungsinformationenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrierungsinformationenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["lanr"] = this.lanr;
        data["bsnr"] = this.bsnr;
        data["kzvnr"] = this.kzvnr;
        data["iknr"] = this.iknr;
        return data;
    }
}

export interface IRegistrierungsinformationenRequestDTO {
    /** Öffentliche E-Mail-Adresse des Teilnehmers zur Versendung von Registrierungsinformationen. */
    email: string;
    /** Lebenslange Arztnummer, optional. */
    lanr?: string;
    /** Betriebsstättennummer, optional. */
    bsnr?: string;
    /** Nummer der Kassenzahnärztlichen Vereinigung, optional. */
    kzvnr?: string;
    /** Institutskennzeichen, optional. */
    iknr?: string;
}

export class TeilnehmerregistrierungRequestDTO implements ITeilnehmerregistrierungRequestDTO {
    registrierungsinformationen?: RegistrierungsinformationenRequestDTO;
    vertragsinformationen?: VertragsinformationenRequestDTO;
    accountinformationen?: AccountinformationenRequestDTO;
    /** Wenn _false_, wird der Versand der Registrierungsmails (Willkommens-E-Mail mit Zertifikatsnummer und E-Mail mit Zertifikatspasswort) unterbunden. Wenn nicht angegeben, steht der Parameter automatisch auf _true_. */
    emailBenachrichtigung?: boolean;

    constructor(data?: ITeilnehmerregistrierungRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrierungsinformationen = _data["registrierungsinformationen"] ? RegistrierungsinformationenRequestDTO.fromJS(_data["registrierungsinformationen"]) : <any>undefined;
            this.vertragsinformationen = _data["vertragsinformationen"] ? VertragsinformationenRequestDTO.fromJS(_data["vertragsinformationen"]) : <any>undefined;
            this.accountinformationen = _data["accountinformationen"] ? AccountinformationenRequestDTO.fromJS(_data["accountinformationen"]) : <any>undefined;
            this.emailBenachrichtigung = _data["emailBenachrichtigung"];
        }
    }

    static fromJS(data: any): TeilnehmerregistrierungRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeilnehmerregistrierungRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrierungsinformationen"] = this.registrierungsinformationen ? this.registrierungsinformationen.toJSON() : <any>undefined;
        data["vertragsinformationen"] = this.vertragsinformationen ? this.vertragsinformationen.toJSON() : <any>undefined;
        data["accountinformationen"] = this.accountinformationen ? this.accountinformationen.toJSON() : <any>undefined;
        data["emailBenachrichtigung"] = this.emailBenachrichtigung;
        return data;
    }
}

export interface ITeilnehmerregistrierungRequestDTO {
    registrierungsinformationen?: RegistrierungsinformationenRequestDTO;
    vertragsinformationen?: VertragsinformationenRequestDTO;
    accountinformationen?: AccountinformationenRequestDTO;
    /** Wenn _false_, wird der Versand der Registrierungsmails (Willkommens-E-Mail mit Zertifikatsnummer und E-Mail mit Zertifikatspasswort) unterbunden. Wenn nicht angegeben, steht der Parameter automatisch auf _true_. */
    emailBenachrichtigung?: boolean;
}

export class VertragsinformationenRequestDTO implements IVertragsinformationenRequestDTO {
    /** kim+ Contract ID des Teilnehmers. */
    kimVertragId: string;

    constructor(data?: IVertragsinformationenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimVertragId = _data["kimVertragId"];
        }
    }

    static fromJS(data: any): VertragsinformationenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VertragsinformationenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimVertragId"] = this.kimVertragId;
        return data;
    }
}

export interface IVertragsinformationenRequestDTO {
    /** kim+ Contract ID des Teilnehmers. */
    kimVertragId: string;
}

export class TeilnehmerregistrierungResponseDTO implements ITeilnehmerregistrierungResponseDTO {
    /** Zeigt an, ob die Registrierung erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Registrierung. */
    fehlerBemerkung?: string;
    /** Token für die weiteren Schritte zur Registrierung des Accounts. */
    registrierungstoken?: string;
    /** ID des zugewiesenen Clientmodul-Zertifikates für späteren Bezug und Anbindung an die TI */
    zertifikatId?: number;

    constructor(data?: ITeilnehmerregistrierungResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.fehlerBemerkung = _data["fehlerBemerkung"];
            this.registrierungstoken = _data["registrierungstoken"];
            this.zertifikatId = _data["zertifikatId"];
        }
    }

    static fromJS(data: any): TeilnehmerregistrierungResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TeilnehmerregistrierungResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["fehlerBemerkung"] = this.fehlerBemerkung;
        data["registrierungstoken"] = this.registrierungstoken;
        data["zertifikatId"] = this.zertifikatId;
        return data;
    }
}

export interface ITeilnehmerregistrierungResponseDTO {
    /** Zeigt an, ob die Registrierung erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Registrierung. */
    fehlerBemerkung?: string;
    /** Token für die weiteren Schritte zur Registrierung des Accounts. */
    registrierungstoken?: string;
    /** ID des zugewiesenen Clientmodul-Zertifikates für späteren Bezug und Anbindung an die TI */
    zertifikatId?: number;
}

export class AccountEntsperrenRequestDTO implements IAccountEntsperrenRequestDTO {
    kimContractId?: string;
    kimEmail?: string;

    constructor(data?: IAccountEntsperrenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimContractId = _data["kimContractId"];
            this.kimEmail = _data["kimEmail"];
        }
    }

    static fromJS(data: any): AccountEntsperrenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEntsperrenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimContractId"] = this.kimContractId;
        data["kimEmail"] = this.kimEmail;
        return data;
    }
}

export interface IAccountEntsperrenRequestDTO {
    kimContractId?: string;
    kimEmail?: string;
}

export class AccountEntsperrenResponseDTO implements IAccountEntsperrenResponseDTO {
    /** Zeigt an, ob das Entsperren erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Entsperrung. */
    bemerkung?: string;
    /** Token für die weiteren Schritte zum Entsperren des Accounts. */
    entsperreToken?: string;

    constructor(data?: IAccountEntsperrenResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bemerkung = _data["bemerkung"];
            this.entsperreToken = _data["entsperreToken"];
        }
    }

    static fromJS(data: any): AccountEntsperrenResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEntsperrenResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bemerkung"] = this.bemerkung;
        data["entsperreToken"] = this.entsperreToken;
        return data;
    }
}

export interface IAccountEntsperrenResponseDTO {
    /** Zeigt an, ob das Entsperren erfolgreich war. */
    success?: boolean;
    /** Information bei Fehlschlag einer Entsperrung. */
    bemerkung?: string;
    /** Token für die weiteren Schritte zum Entsperren des Accounts. */
    entsperreToken?: string;
}

export class AccountDeregistrierenFrontendRequestDTO implements IAccountDeregistrierenFrontendRequestDTO {
    kimEmail?: string;
    passwort?: string;
    kimContractId?: string;

    constructor(data?: IAccountDeregistrierenFrontendRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kimEmail = _data["kimEmail"];
            this.passwort = _data["passwort"];
            this.kimContractId = _data["kimContractId"];
        }
    }

    static fromJS(data: any): AccountDeregistrierenFrontendRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDeregistrierenFrontendRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kimEmail"] = this.kimEmail;
        data["passwort"] = this.passwort;
        data["kimContractId"] = this.kimContractId;
        return data;
    }
}

export interface IAccountDeregistrierenFrontendRequestDTO {
    kimEmail?: string;
    passwort?: string;
    kimContractId?: string;
}

export class HoleMailDomaeneFuerVertragResponseDTO implements IHoleMailDomaeneFuerVertragResponseDTO {
    /** Zeigt an, ob der Aufruf erfolgreich war. */
    success?: boolean;
    /** Fehlerbemerkung */
    bemerkung?: string;
    mailDomaenen?: MailDomaeneDTO[];

    constructor(data?: IHoleMailDomaeneFuerVertragResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bemerkung = _data["bemerkung"];
            if (Array.isArray(_data["mailDomaenen"])) {
                this.mailDomaenen = [] as any;
                for (let item of _data["mailDomaenen"])
                    this.mailDomaenen.push(MailDomaeneDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HoleMailDomaeneFuerVertragResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HoleMailDomaeneFuerVertragResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bemerkung"] = this.bemerkung;
        if (Array.isArray(this.mailDomaenen)) {
            data["mailDomaenen"] = [];
            for (let item of this.mailDomaenen)
                data["mailDomaenen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHoleMailDomaeneFuerVertragResponseDTO {
    /** Zeigt an, ob der Aufruf erfolgreich war. */
    success?: boolean;
    /** Fehlerbemerkung */
    bemerkung?: string;
    mailDomaenen?: MailDomaeneDTO[];
}

export class MailDomaeneDTO implements IMailDomaeneDTO {
    /** Name der Maildomäne */
    name?: string;

    constructor(data?: IMailDomaeneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MailDomaeneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailDomaeneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IMailDomaeneDTO {
    /** Name der Maildomäne */
    name?: string;
}

export class ErrorDTOCodeContainer implements IErrorDTOCodeContainer {
    /** Error Codes */
    codes?: ErrorDTOCodeContainerCodes;
    /** Error Subcodes */
    subcodes?: ErrorDTOCodeContainerSubcodes;

    constructor(data?: IErrorDTOCodeContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codes = _data["codes"];
            this.subcodes = _data["subcodes"];
        }
    }

    static fromJS(data: any): ErrorDTOCodeContainer {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDTOCodeContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codes"] = this.codes;
        data["subcodes"] = this.subcodes;
        return data;
    }
}

export interface IErrorDTOCodeContainer {
    /** Error Codes */
    codes?: ErrorDTOCodeContainerCodes;
    /** Error Subcodes */
    subcodes?: ErrorDTOCodeContainerSubcodes;
}

export enum ErrorDTOCodeContainerCodes {
    ValidationError = <any>"ValidationError",
    AdPermissionMissing = <any>"AdPermissionMissing",
    AdLoginNotFound = <any>"AdLoginNotFound",
    IllegalState = <any>"IllegalState",
    UnknownError = <any>"UnknownError",
    OptimisticLockingError = <any>"OptimisticLockingError",
}

export enum ErrorDTOCodeContainerSubcodes {
    Unknown = <any>"Unknown",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
